import { fetcher } from '../../http/Fetcher';
import type {
    DeviceTokenResponse,
    ForgotPasswordRequest,
    ForgotPasswordResponse,
    GetDeviceTokenRequest,
    ResetPasswordRequest,
    ResetPasswordResponse,
} from '../types/Auth';

export const startForgotPassword = async (
    request: ForgotPasswordRequest,
): Promise<ForgotPasswordResponse> => {
    const { email, source, visitorId } = request;
    const body = {
        email,
        ...(source != null ? { source } : {}),
        ...(visitorId != null ? { visitorId } : {}),
    };

    return await fetcher({
        method: 'POST',
        endpoint: '/api/auth/passwords/forgot',
        body: JSON.stringify(body),
    });
};

export const resetPassword = async (
    request: ResetPasswordRequest,
): Promise<ResetPasswordResponse> => {
    const { password, token } = request;

    return await fetcher({
        method: 'POST',
        endpoint: '/api/auth/passwords/reset',
        body: JSON.stringify({
            password,
            token,
            sessionDurationMinutes: 15,
        }),
    });
};

export async function fetchDeviceToken(
    request: GetDeviceTokenRequest,
): Promise<DeviceTokenResponse | null> {
    const { stytchId, sessionId, isFirstLogin } = request;
    return await fetcher({
        method: 'GET',
        endpoint: `/api/mfa/device-token?stytch_id=${stytchId}&session_id=${sessionId}&is_first_login=${String(
            isFirstLogin,
        )}`,
    });
}
